<template lang="pug">
  .notification
    .notification__header
      .notification__title
        template(v-if="isAdmin")
          | ConPlus не оплачен {{ payload.daysPassed }} дней
        template(v-else)
          template(v-if="deleteDateDiff / 30 >= 1")
            | Через {{ deleteDateDiff / 30 | round }} месяца ваш личный кабинет будет удален
          template(v-else)
            | Через {{ deleteDateDiff / 7 | round}} недели ваш личный кабинет будет удален
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="isAdmin")
          | Пользователь:
          strong {{ payload.firmName }}
          br
          a(v-bind:href="'mailto:' + payload.firmEmail") {{ payload.firmEmail }}
        template(v-else)
          template(v-if="deleteDateDiff / 30 >= 1")
            | Ваш ConPlus заблокирован. Личный кабинет и данные о клиентах будут доступны еще
            | {{ deleteDateDiff / 30 | round }} месяца.
          template(v-else)
            | Чтобы избежать потери ваших данных о клиентах и заказах, оплатите тариф.
          br
          router-link.notification__link(
            @click.native="emitClick"
            title="Перейти к оплате"
            :to="{name: 'payments'}"
          ) Перейти к оплате
</template>

<script>
import notification from '@/mixins/notification.mixin';
import { differenceInDays } from 'date-fns';

export default {
  name: 'PackageEndedDaysBack',
  mixins: [notification],

  computed: {
    deleteDateDiff() {
      if (this.payload.deleteDate) {
        return differenceInDays(
          new Date(this.payload.deleteDate.date),
          new Date(this.createdAt)
        );
      } else {
        return false;
      }
    }
  },

  filters: {
    round(value) {
      return Math.round(value * 10) / 10;
    }
  }
};
</script>
